var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerAsset1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 553,
    viewBox: "0 0 332 553",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_783_1940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.000244141 334.648H237.604",
    stroke: "#B09683",
    strokeWidth: 1.22616,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000244141 405.668H237.604",
    stroke: "#B09683",
    strokeWidth: 1.22616,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000244141 98.0931H237.604",
    stroke: "#B09683",
    strokeWidth: 1.22616,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000244141 127.521H237.604",
    stroke: "#B09683",
    strokeWidth: 1.22616,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000244141 156.949H237.604",
    stroke: "#B09683",
    strokeWidth: 1.22616,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.45 538.286L237.876 538.286",
    stroke: "#B09683",
    strokeWidth: 1.22616,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.605 553V0",
    stroke: "#B09683",
    strokeWidth: 1.22616,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.129 553V0",
    stroke: "#B09683",
    strokeWidth: 1.22616,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.652 553V0",
    stroke: "#B09683",
    strokeWidth: 1.22616,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.175 553V0",
    stroke: "#B09683",
    strokeWidth: 1.22616,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9052 258.337V334.659H0.00366211V139.821L0.249223 187.267C10.7114 187.254 21.0732 189.086 30.7392 192.658C40.4052 196.23 49.1848 201.471 56.5734 208.08C63.9802 214.674 69.8542 222.507 73.8582 231.132C77.8622 239.756 79.9172 249.002 79.9052 258.337Z",
    stroke: "#B09683",
    strokeWidth: 1.22616,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.954 253.941V334.65H237.851V182.863H237.612C227.152 182.862 216.794 184.699 207.13 188.271C197.466 191.842 188.685 197.077 181.289 203.677C173.892 210.276 168.025 218.111 164.023 226.734C160.02 235.357 157.961 244.599 157.961 253.933L157.954 253.941Z",
    stroke: "#B09683",
    strokeWidth: 1.22616,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9052 296.047H0.00366211",
    stroke: "#B09683",
    strokeWidth: 1.22616,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9052 303.589H0.00366211",
    stroke: "#B09683",
    strokeWidth: 1.22616,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9052 311.131H0.00366211",
    stroke: "#B09683",
    strokeWidth: 1.22616,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9052 318.669H0.00366211",
    stroke: "#B09683",
    strokeWidth: 1.22616,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9052 326.211H0.00366211",
    stroke: "#B09683",
    strokeWidth: 1.22616,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41724e-05 553L0 0",
    stroke: "#B09683",
    strokeWidth: 1.22616,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.676 553V98.0931",
    stroke: "#B09683",
    strokeWidth: 1.23939,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.676 98.0931V0",
    stroke: "#B09683",
    strokeWidth: 1.23939,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7007 98.0931V0",
    stroke: "#B09683",
    strokeWidth: 1.23939,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.676 98.0931L237.876 0",
    stroke: "#B09683",
    strokeWidth: 1.23939,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7251 98.0931V0",
    stroke: "#B09683",
    strokeWidth: 1.23939,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7495 98.0931V0",
    stroke: "#B09683",
    strokeWidth: 1.23939,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000244141 502.727C5.92536 502.727 5.92533 510.084 11.8504 510.084C17.7756 510.084 17.7755 502.727 23.7006 502.727C29.6258 502.727 29.6258 510.084 35.5531 510.084C41.4804 510.084 41.4782 502.727 47.4011 502.727C53.324 502.727 53.3263 510.084 59.2514 510.084C65.1765 510.084 65.1787 502.727 71.106 502.727C77.0333 502.727 77.0311 510.084 82.9584 510.084C88.8858 510.084 88.8879 502.727 94.8174 502.727C100.747 502.727 100.747 510.084 106.677 510.084",
    stroke: "#B09683",
    strokeWidth: 1.23939,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000244141 475.752C5.92536 475.752 5.92533 483.109 11.8504 483.109C17.7756 483.109 17.7755 475.752 23.7006 475.752C29.6258 475.752 29.6258 483.109 35.5531 483.109C41.4804 483.109 41.4782 475.752 47.4011 475.752C53.324 475.752 53.3263 483.109 59.2514 483.109C65.1765 483.109 65.1787 475.752 71.106 475.752C77.0333 475.752 77.0311 483.109 82.9584 483.109C88.8858 483.109 88.8879 475.752 94.8174 475.752C100.747 475.752 100.747 483.109 106.677 483.109",
    stroke: "#B09683",
    strokeWidth: 1.23939,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000244141 448.776C5.92536 448.776 5.92533 456.133 11.8504 456.133C17.7756 456.133 17.7755 448.776 23.7006 448.776C29.6258 448.776 29.6258 456.133 35.5531 456.133C41.4804 456.133 41.4782 448.776 47.4011 448.776C53.324 448.776 53.3263 456.133 59.2514 456.133C65.1765 456.133 65.1787 448.776 71.106 448.776C77.0333 448.776 77.0311 456.133 82.9584 456.133C88.8858 456.133 88.8879 448.776 94.8174 448.776C100.747 448.776 100.747 456.133 106.677 456.133",
    stroke: "#B09683",
    strokeWidth: 1.23939,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000244141 421.8C5.92536 421.8 5.92533 429.157 11.8504 429.157C17.7756 429.157 17.7755 421.8 23.7006 421.8C29.6258 421.8 29.6258 429.157 35.5531 429.157C41.4804 429.157 41.4782 421.8 47.4011 421.8C53.324 421.8 53.3263 429.157 59.2514 429.157C65.1765 429.157 65.1787 421.8 71.106 421.8C77.0333 421.8 77.0311 429.157 82.9584 429.157C88.8858 429.157 88.8879 421.8 94.8174 421.8C100.747 421.8 100.747 429.157 106.677 429.157",
    stroke: "#B09683",
    strokeWidth: 1.23939,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000244141 529.703C5.92536 529.703 5.92533 538.286 11.8504 538.286C17.7756 538.286 17.7755 529.703 23.7006 529.703C29.6258 529.703 29.6258 538.286 35.5531 538.286C41.4804 538.286 41.4782 529.703 47.4011 529.703C53.324 529.703 53.3263 538.286 59.2514 538.286C65.1765 538.286 65.1787 529.703 71.106 529.703C77.0333 529.703 77.0311 538.286 82.9584 538.286C88.8858 538.286 88.8879 529.703 94.8174 529.703C100.747 529.703 100.747 538.286 106.677 538.286",
    stroke: "#B09683",
    strokeWidth: 1.23939,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.676 519.894L172.276 405.86L237.876 519.894H106.676Z",
    stroke: "#B09683",
    strokeWidth: 1.23939,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_783_1940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 331.064,
    height: 553,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerAsset1);
export default __webpack_public_path__ + "static/media/banner-asset-1.481ab39eb13e5e7723eb035feebc1bb9.svg";
export { ForwardRef as ReactComponent };